// Aeróbicos y dancefit no se hacen sobre bicicleta: no hay sitio asignado.
// En vez del mapa de bicis, aquí se elige CUÁNTOS lugares se reservan y el
// sistema se queda con los números libres más bajos (siguen guardándose en
// `seats`, que es lo que impide que dos personas ocupen el mismo lugar).

export const SpotPicker = ({ capacity, bookedSpots, count, onChange, t }) => {
  const free = capacity - bookedSpots.length;
  const max = Math.min(free, 6);

  return (
    <div data-testid="spot-picker">
      <p className="text-sm text-zinc-500 font-light leading-relaxed">{t.spotsHint}</p>

      <div className="mt-10 border border-[#232323] px-7 py-8">
        <p className="overline-gold font-sans">{t.howMany}</p>

        <div className="mt-6 flex items-center gap-7">
          <button
            type="button"
            data-testid="spots-minus"
            onClick={() => onChange(Math.max(1, count - 1))}
            disabled={count <= 1}
            aria-label="−"
            className="h-12 w-12 border border-[#232323] text-2xl text-zinc-400 transition-colors duration-300 hover:border-[#C5A059] hover:text-[#C5A059] disabled:opacity-30 disabled:hover:border-[#232323] disabled:hover:text-zinc-400"
          >
            −
          </button>

          <span data-testid="spots-count" className="font-serif text-5xl text-white w-14 text-center tabular-nums">
            {count}
          </span>

          <button
            type="button"
            data-testid="spots-plus"
            onClick={() => onChange(Math.min(max, count + 1))}
            disabled={count >= max}
            aria-label="+"
            className="h-12 w-12 border border-[#232323] text-2xl text-zinc-400 transition-colors duration-300 hover:border-[#C5A059] hover:text-[#C5A059] disabled:opacity-30 disabled:hover:border-[#232323] disabled:hover:text-zinc-400"
          >
            +
          </button>
        </div>

        <p className="mt-7 text-xs uppercase tracking-[0.25em] text-zinc-500">
          {free} {t.spotsAvailable}
        </p>
      </div>
    </div>
  );
};

/** Los `count` números de lugar libres más bajos de la clase. */
export const freeSpots = (capacity, bookedSpots, count) => {
  const taken = new Set(bookedSpots);
  const out = [];
  for (let n = 1; n <= capacity && out.length < count; n++) {
    if (!taken.has(n)) out.push(n);
  }
  return out;
};
